import type { MessageDescriptor } from '@lingui/core';
import { i18n } from '@lingui/core';
import { toApiError } from './api-error';
import { getErrorReason, GetErrorReasonOptions } from './get-error-reason';

/**
 * Текст тоста об ошибке: заголовок места вызова + переведённая причина, если она есть.
 *
 * «Не удалось удалить игрока. Игрок не найден — возможно, его уже удалили. Обновите страницу.»
 * Нет перевода — только заголовок, как раньше. Исходный английский текст уходит в
 * `console.error`: пользователю его не показываем, но при разборе он нужен.
 *
 * Глобальный `i18n` (а не `useLingui`) — чтобы текст собирался и вне `I18nProvider`
 * (`useDispatchWithToast` зовут и компоненты, которые тесты рендерят без провайдера).
 * Вызывать только в момент показа — не на уровне модуля.
 */
export function describeApiError(error: unknown, title: MessageDescriptor, options?: GetErrorReasonOptions): string {
  const titleText = i18n._(title);
  const reason = getErrorReason(error, options);

  console.error(`${titleText}:`, toApiError(error));

  return reason ? `${titleText}. ${i18n._(reason)}` : titleText;
}
